import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { NavLink, useNavigate, useParams } from "react-router";
import { CatalogInfoCard } from "@/routes/base-data/processes/qpm/catalog/[catalogId]/_components/catalog-info-card";
import { Button } from "@/shared/components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useQpmCatalogGetQuery } from "@/services/backend/qpm/catalog/api/catalog-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { isFetchBaseQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { useEffect, useState } from "react";
import { CatalogMonitorsListCard } from "@/routes/base-data/processes/qpm/catalog/[catalogId]/_components/monitor-list-card-component";

export function CatalogRoutePage() {
  const params = useParams();

  const {
    data: catalog,
    error,
    isLoading,
  } = useQpmCatalogGetQuery(
    { id: params.catalogId! },
    { skip: !params.catalogId },
  );

  if (error) {
    if (
      isFetchBaseQueryError(error) &&
      (error.status === 404 || error.status === 500)
    ) {
      return <CatalogDeletedOrMissingRedirectCard />;
    }
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <Loader2 className="animate-spin" />;
  }

  if (!params.catalogId) {
    return <div>{t("Katalog ID nicht gefunden.")}</div>;
  }

  if (!error && !isLoading && !catalog) {
    return <CatalogDeletedOrMissingRedirectCard />;
  }

  return (
    catalog && (
      <div className="flex flex-col gap-2">
        <CatalogInfoCard catalog={catalog} />
        <CatalogMonitorsListCard catalogId={catalog.id} />
      </div>
    )
  );
}

function CatalogDeletedOrMissingRedirectCard() {
  const REDIRECT_TIMER_SECONDS = 5;
  const CATALOG_OVERVIEW_PATH = "/base-data/processes/qpm/catalog";
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(REDIRECT_TIMER_SECONDS);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => Math.max(prev - 1, 0));
    }, 1000);

    const timeout = setTimeout(() => {
      navigate(CATALOG_OVERVIEW_PATH);
    }, REDIRECT_TIMER_SECONDS * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col gap-4">
          <NavLink to={CATALOG_OVERVIEW_PATH}>
            <Button variant="outline" size="sm" className="m-0">
              <ArrowLeft className="mr-2 h-4 w-4" />
              <span>{t("Zur Katalogübersicht")}</span>
            </Button>
          </NavLink>
          <CardTitle>
            {t("Katalog wurde gelöscht oder nicht gefunden")}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-2">
          <span>
            {t("Sie werden in")} {seconds} {t("Sekunden weitergeleitet")}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
